export default __webpack_public_path__ + "static/axur-seguranca-cibernetica-225068beadd9e122b1dd7f97ecff2a94.jpg";